import React, { useState } from "react";
import { useAuth } from "../../Store/AuthContext";
import NotifyMessageNoReload from "../../Utils/NotifyMessageNoReload";
import APIDataFetchLoader from "../../Utils/APIDataFetchLoader";
import axios from "axios";
import { ServiceFetchData } from "../../APIS/FetchAPIs";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "admin/API/";

export default function ContactFormEnquery() {
  const { RendomTokenfetch } = useAuth();
  const [ServiceData] = ServiceFetchData(RendomTokenfetch);

  const [fullname, setfullname] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setemail] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setdescriptions] = useState("");
  const [loading, setLoading] = useState(false);

  const handleKeyPress = (e) => {
    const charCode = e.which || e.keyCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (value.length <= 10) {
      setMobileNumber(value);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (fullname && mobileNumber && email) {
      setLoading(true);
      let fdata = new FormData();
      fdata.append("name", fullname);
      fdata.append("number", mobileNumber);
      fdata.append("email", email);
      fdata.append("subject", subject);
      fdata.append("message", description);

      try {
        const response = await axios.post(
          `${WebsiteAPIurl}contentEnquiryAPI.php`,
          fdata,
          {
            headers: {
              Authorization: RendomTokenfetch,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        // console.log(response.data);
        if (response.data.status === "1") {
          NotifyMessageNoReload(response.data.message, "success");
          setfullname("");
          setMobileNumber("");
          setemail("");
          setSubject("");
          setdescriptions("");
        } else {
          NotifyMessageNoReload(response.data.message, "danger");
        }
      } catch (error) {
        NotifyMessageNoReload(
          "Failed to send message. Please try again.",
          "danger"
        );
      } finally {
        setLoading(false);
      }
    } else {
      NotifyMessageNoReload(
        "All fields are required. Please try again.",
        "danger"
      );
    }
  };

  if (loading) {
    return <APIDataFetchLoader />;
  }
  return (
    <>
      <form className="form was-validated" onSubmit={handleSubmit}>
        <div className="row g-4">
          <div className="col-lg-12">
            <div className="form-clt">
              <input
                className="form-control"
                type="text"
                name="userName"
                value={fullname}
                onChange={(e) => setfullname(e.target.value)}
                placeholder="Name*"
                required
              />
            </div>
          </div>
          <div className="col-lg-12 ">
            <div className="form-clt">
              <input
                type="email"
                className="form-control"
                id="useremail"
                name="useremail"
                value={email}
                onChange={(e) => setemail(e.target.value)}
                placeholder="Email Address"
                required
              />
            </div>
          </div>
          <div className="col-lg-12 ">
            <div className="form-clt">
              <input
                type="text"
                className="form-control"
                id="usernumber"
                name="usernumber"
                onChange={handleMobileChange}
                onKeyPress={handleKeyPress}
                value={mobileNumber}
                maxLength={10}
                inputMode="numeric"
                placeholder="Contact number*"
                required
              />
            </div>
          </div>
          <div className="col-lg-12 ">
            <div className="form-clt">
              <select
                className="form-control w-100 "
                name="subject"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              >
                <option value="">Select</option>
                {ServiceData.map((sub, index) => (
                  <option value={sub.title} key={index}>
                    {sub.title}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="form-clt">
              <textarea
                className="form-control"
                id="message"
                name="message"
                value={description}
                onChange={(e) => setdescriptions(e.target.value)}
                rows="4"
                placeholder="Write Your Message*"
              ></textarea>
            </div>
          </div>
          <div className="col-lg-12 ">
            <button className="Homebtn" type="submit" name="submit">
              Send Message
            </button>
          </div>
        </div>
      </form>
    </>
  );
}
